// The Healing Herb Garden — shared section behaviours.
(function () {
  function reveal(root) {
    var items = root.querySelectorAll(
      '.hhg-reveal:not([data-hhg-ready])'
    );

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      items.forEach(function (item) {
        item.dataset.hhgReady = 'true';
        item.classList.add('hhg-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hhg-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    items.forEach(function (item) {
      item.dataset.hhgReady = 'true';
      observer.observe(item);
    });
  }

  function accordions(root) {
    root
      .querySelectorAll('[data-hhg-faq]:not([data-hhg-ready])')
      .forEach(function (list) {
        list.dataset.hhgReady = 'true';

        list.addEventListener('click', function (event) {
          var button = event.target.closest('.hhg-faq-q');

          if (!button || !list.contains(button)) return;

          var item = button.closest('.hhg-faq-item');
          var answer = item.querySelector('.hhg-faq-a');
          var opening =
            button.getAttribute('aria-expanded') !== 'true';

          list
            .querySelectorAll(
              '.hhg-faq-q[aria-expanded="true"]'
            )
            .forEach(function (other) {
              other.setAttribute('aria-expanded', 'false');

              var otherPanel = document.getElementById(
                other.getAttribute('aria-controls')
              );

              if (otherPanel) {
                otherPanel.hidden = true;
              }
            });

          button.setAttribute(
            'aria-expanded',
            String(opening)
          );

          answer.hidden = !opening;
        });
      });
  }

  function countdowns(root) {
    root
      .querySelectorAll(
        '[data-hhg-countdown]:not([data-hhg-ready])'
      )
      .forEach(function (element) {
        element.dataset.hhgReady = 'true';

        var target = new Date(
          element.getAttribute('data-hhg-countdown')
        );

        var value = element.querySelector(
          '.hhg-countdown-value'
        );

        if (!value || isNaN(target.getTime())) {
          if (value) {
            value.textContent = 'date to be confirmed';
          }
          return;
        }

        var days = Math.ceil(
          (target - new Date()) / 86400000
        );

        value.textContent =
          days <= 0
            ? 'now — final days'
            : days + (days === 1 ? ' day' : ' days');
      });
  }

  function wheel(root) {
    root
      .querySelectorAll(
        '[data-hhg-wheel]:not([data-hhg-ready])'
      )
      .forEach(function (stage) {
        stage.dataset.hhgReady = 'true';

        var detail =
          stage.parentElement.querySelector(
            '.hhg-wheel-detail'
          );

        var segments =
          stage.querySelectorAll('.hhg-quadrant');

        function activate(segment) {
          segments.forEach(function (item) {
            item.setAttribute(
              'aria-selected',
              String(item === segment)
            );
          });

          if (!detail) return;

          var heading = detail.querySelector('h3');
          var paragraph = detail.querySelector('p');
          var link = detail.querySelector('a');

          if (heading) {
            heading.textContent =
              segment.dataset.name || '';
          }

          if (paragraph) {
            paragraph.textContent =
              segment.dataset.items || '';
          }

          if (link && segment.dataset.link) {
            link.href = segment.dataset.link;
          }
        }

        segments.forEach(function (segment) {
          segment.addEventListener(
            'click',
            function () {
              activate(segment);
            }
          );

          segment.addEventListener(
            'focus',
            function () {
              activate(segment);
            }
          );

          segment.addEventListener(
            'mouseenter',
            function () {
              activate(segment);
            }
          );
        });

        if (segments[0]) {
          activate(segments[0]);
        }
      });
  }

  function tabs(root, selector) {
    root
      .querySelectorAll(
        selector + ':not([data-hhg-ready])'
      )
      .forEach(function (component) {
        component.dataset.hhgReady = 'true';

        var buttons =
          component.querySelectorAll('[role="tab"]');

        var panels =
          component.querySelectorAll(
            '[role="tabpanel"]'
          );

        function activate(button, focus) {
          var panelId =
            button.getAttribute('aria-controls');

          buttons.forEach(function (item) {
            var selected = item === button;

            item.setAttribute(
              'aria-selected',
              String(selected)
            );

            item.tabIndex = selected ? 0 : -1;
          });

          panels.forEach(function (panel) {
            panel.hidden = panel.id !== panelId;
          });

          if (focus) {
            button.focus();
          }
        }

        buttons.forEach(function (button, index) {
          button.addEventListener(
            'click',
            function () {
              activate(button, false);
            }
          );

          button.addEventListener(
            'keydown',
            function (event) {
              if (
                event.key !== 'ArrowRight' &&
                event.key !== 'ArrowLeft'
              ) {
                return;
              }

              event.preventDefault();

              var next =
                event.key === 'ArrowRight'
                  ? (index + 1) % buttons.length
                  : (index - 1 + buttons.length) %
                    buttons.length;

              activate(buttons[next], true);
            }
          );
        });

        if (buttons[0]) {
          activate(buttons[0], false);
        }
      });
  }

  function initialise(root) {
    reveal(root);
    accordions(root);
    countdowns(root);
    wheel(root);

    tabs(
      root,
      '[data-hhg-plant-explorer]'
    );

    tabs(
      root,
      '[data-hhg-timeline]'
    );
  }

  function start() {
    initialise(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialise(event.target);
    }
  );
})();